import { type AlgoliaBaseProduct, AlgoliaProductProperties } from "@lib/wrappers/algolia/types";

export const DEFAULT_ATTRIBUTES_TO_RETRIEVE: (keyof AlgoliaBaseProduct)[] = [
    AlgoliaProductProperties.articleNumber,
    AlgoliaProductProperties.productColors,
    AlgoliaProductProperties.objectID,
    AlgoliaProductProperties.colorCode,
    AlgoliaProductProperties.categories,
    AlgoliaProductProperties.hasDiscount,
    AlgoliaProductProperties.eaBadge,
    AlgoliaProductProperties.image,
    AlgoliaProductProperties.imageLabel,
    AlgoliaProductProperties.hasStock,
    AlgoliaProductProperties.name,
    AlgoliaProductProperties.listPriceRaw,
    AlgoliaProductProperties.priceRaw,
    AlgoliaProductProperties.lowestPriceRaw,
    AlgoliaProductProperties.discountPercentageLowestPrice,
    AlgoliaProductProperties.priceWithDiscount,
    AlgoliaProductProperties.priceWithoutDiscount,
    AlgoliaProductProperties.variants,
    AlgoliaProductProperties.backgroundColor,
    AlgoliaProductProperties.discountPercentage,
    AlgoliaProductProperties.badges,
    AlgoliaProductProperties.listPrice,
    AlgoliaProductProperties.bestseller,
    AlgoliaProductProperties.onlineExclusive,
    AlgoliaProductProperties.group,
    AlgoliaProductProperties.collectionClass,
    AlgoliaProductProperties.collectionType,
];
